import type { JSX } from 'react'

import { Skeleton } from 'blocks/Skeletons'
import { SkeletonUnitDirection } from 'blocks/Skeletons/components/SkeletonUnit'
import { SkeletonUnitSC } from 'blocks/Skeletons/components/SkeletonUnit/SkeletonUnit.styled'
import {
  CloseBtnSkeletonSC,
  PlaylistHeaderSkeletonSC,
  PlaylistImageSkeletonSC,
  PlaylistItemSubTitleSkeletonSC,
  PlaylistItemTitleSkeletonSC,
  PlaylistSkeletonGradientSC,
  PlaylistTitleSkeletonSC,
} from './PlaylistSkeleton.styled'

// https://www.figma.com/design/5kpGl40sfd6ng2g2Lh3pnQ/Web-3.0-New?node-id=5669-24168&t=6dlBNsC5rOvsRixJ-1
export const PlaylistSkeleton = (): JSX.Element => {
  return (
    <Skeleton>
      <PlaylistHeaderSkeletonSC>
        <PlaylistTitleSkeletonSC />
        <CloseBtnSkeletonSC />
      </PlaylistHeaderSkeletonSC>
      <PlaylistSkeletonGradientSC>
        {[...Array(5)].map((i) => (
          <SkeletonUnitSC direction={SkeletonUnitDirection.Row} key={i}>
            <PlaylistImageSkeletonSC />
            <SkeletonUnitSC direction={SkeletonUnitDirection.Column}>
              <PlaylistItemTitleSkeletonSC />
              <PlaylistItemSubTitleSkeletonSC />
            </SkeletonUnitSC>
          </SkeletonUnitSC>
        ))}
      </PlaylistSkeletonGradientSC>
    </Skeleton>
  )
}
